import { render, staticRenderFns } from "./1688list.vue?vue&type=template&id=eb1aa56e&scoped=true&"
import script from "./1688list.vue?vue&type=script&lang=js&"
export * from "./1688list.vue?vue&type=script&lang=js&"
import style0 from "./1688list.vue?vue&type=style&index=0&id=eb1aa56e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1aa56e",
  null
  
)

export default component.exports